import { render, staticRenderFns } from "./myTemplate.vue?vue&type=template&id=8545671e&scoped=true"
import script from "./myTemplate.vue?vue&type=script&lang=js"
export * from "./myTemplate.vue?vue&type=script&lang=js"
import style0 from "./myTemplate.vue?vue&type=style&index=0&id=8545671e&prod&lang=less"
import style1 from "./myTemplate.vue?vue&type=style&index=1&id=8545671e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8545671e",
  null
  
)

export default component.exports